

























import { Component, Vue, Prop, Inject, Watch } from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import { IValue } from './RadioTypes';

@Component({})
export default class Radio extends Vue {
  @Prop({ required: true }) name!: String;
  @Prop({ required: true }) values!: IValue[];
  @Prop({ default: false }) required!: boolean;
  @Prop({ default: '' }) checked!: string;
  @Prop({ default: '' }) displayName!: string;
  @Prop({ default: false }) error!: boolean;
  @Prop({ default: '' }) errorMessage!: string;
  @Prop({ default: '' }) asBlock!: string;
  @Prop({ default: '' }) black!: string;
  @Inject('$validator') public $validator!: Validator;

  value: string = '';
  toError: boolean = false;

  @Watch('error')
  onError(newValue: boolean) {
    if (newValue) {
      this.toError = !(this.value || this.checked);
    }
  }

  changeValue(newValue: string) {
    this.value = newValue;
    this.toError = false;
    this.$emit('onChange', newValue);
  }
}
